import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute, PublicRoute } from "../services/AuthContext";

// Loading component for Suspense Fallback
const LoadingFallback = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <h2>Loading...</h2>
  </div>
);

// ✅ Dynamic Imports (Lazy Loading) - Modules will only load when the route is visited
const Login = React.lazy(() => import("../components/auth/Login"));
const ForgetPassword = React.lazy(() => import("../components/auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("../components/auth/ResetPassword"));
const ResetPasswordSuccessfull = React.lazy(() => import("../components/auth/ResetPasswordSuccessfull"));
const VerifyOTP = React.lazy(() => import("../components/auth/VerifyOTP"));

const AdminHome = React.lazy(() => import("../components/home/AdminHome"));
const ClientHome = React.lazy(() => import("../components/client-management/ClientHome"));
const EventHome = React.lazy(() => import("../components/event-management/Events/EventHome"));
const SafesHome = React.lazy(() => import("../components/safes-management/SafesHome"));
const LockerHome = React.lazy(() => import("../components/locker-management/locker/LockerHome"));
const LockerHistory = React.lazy(() => import("../components/locker-management/locker/LockerHistory"));
const HomeFinance = React.lazy(() => import("../components/financial-management/financial/HomeFinance"));
const UpgradeLocker = React.lazy(() => import("../components/reusable/Client/UpgradeLocker"));
const UpgradeSafe = React.lazy(() => import("../components/reusable/Client/UpgradeSafe"));
const RenewalHome = React.lazy(() => import("../components/RenewalEmails/RenewalHome"));
const ViewClientVisitHistroy = React.lazy(() => import("../components/client-management/ViewClientVisitHistroy"));
const ClientDetailsViewAdmin = React.lazy(() => import("../components/client-management/ClientDetailsViewAdmin"));
const LockerSafeAllocate = React.lazy(() => import("../components/client-management/LockerSafeAllocate"));
const PaymentCalculator = React.lazy(() => import("../components/payment-management/payment-calc/PaymentCalculator"));
const HomeSetting = React.lazy(() => import("../components/settings/HomeSetting"));
const PaymentHome = React.lazy(() => import("../components/payment-method/PaymentHome"));
const ApplicationApprovalHome = React.lazy(() => import("../components/ApplicationApprovals/ApplicationApprovalHome"));
const ApplicationDetailView = React.lazy(() => import("../components/ApplicationApprovals/ApplicationDetailView"));
const AssignUpgradeLocker = React.lazy(() => import("../components/AssignLocker/AssignUpgradeLocker"));
const AssignUpgradeSafe = React.lazy(() => import("../components/AssignLocker/AssignUpgradeSafe"));
const PendingRegistrations = React.lazy(() => import("../components/client-management/PendingRegistrations"));

const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute><ForgetPassword /></PublicRoute>} />
        <Route path="/reset-password-successfull" element={<PublicRoute><ResetPasswordSuccessfull /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
        <Route path="/verify-otp" element={<PublicRoute><VerifyOTP /></PublicRoute>} />

        {/* Protected Routes */}
        <Route path="/admin-home" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
        <Route path="/clients" element={<ProtectedRoute><ClientHome /></ProtectedRoute>} />
        <Route path="/events" element={<ProtectedRoute><EventHome /></ProtectedRoute>} />
        <Route path="/safes" element={<ProtectedRoute><SafesHome /></ProtectedRoute>} />
        <Route path="/lockers" element={<ProtectedRoute><LockerHome /></ProtectedRoute>} />
        <Route path="/lockers/history" element={<ProtectedRoute><LockerHistory /></ProtectedRoute>} />
        <Route path="/finance-home" element={<ProtectedRoute><HomeFinance /></ProtectedRoute>} />
        <Route path="/upgrade-locker" element={<ProtectedRoute><UpgradeLocker /></ProtectedRoute>} />
        <Route path="/upgrade-safe" element={<ProtectedRoute><UpgradeSafe /></ProtectedRoute>} />
        <Route path="/renewal-mails" element={<ProtectedRoute><RenewalHome /></ProtectedRoute>} />
        <Route path="/visit-history" element={<ProtectedRoute><ViewClientVisitHistroy /></ProtectedRoute>} />
        <Route path="/admin-client-details-show" element={<ProtectedRoute><ClientDetailsViewAdmin /></ProtectedRoute>} />
        <Route path="/locker-safe-allocate" element={<ProtectedRoute><LockerSafeAllocate /></ProtectedRoute>} />
        <Route path="/payment-calculator" element={<ProtectedRoute><PaymentCalculator /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><HomeSetting /></ProtectedRoute>} />
        <Route path="/payment-method" element={<ProtectedRoute><PaymentHome /></ProtectedRoute>} />
        <Route path="/application-approvals" element={<ProtectedRoute><ApplicationApprovalHome /></ProtectedRoute>} />
        <Route path="/application-approvals/:id" element={<ProtectedRoute><ApplicationDetailView /></ProtectedRoute>} />
        <Route path="/assign-upgrade-locker" element={<ProtectedRoute><AssignUpgradeLocker /></ProtectedRoute>} />
        <Route path="/assign-upgrade-safe" element={<ProtectedRoute><AssignUpgradeSafe /></ProtectedRoute>} />
        <Route path="/pending-registrations" element={<ProtectedRoute><PendingRegistrations /></ProtectedRoute>} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
